export default "__VITE_ASSET__c44c8b7e__"